export const SR_POSTED_LOADING_START = 'SR_POSTED_LOADING_START';
export const SR_POSTED_LOADING_END = 'SR_POSTED_LOADING_END';
export const SR_CONTRACT_START = 'SR_CONTRACT_START';
export const SR_CONTRACT_END = 'SR_CONTRACT_END';
export const SR_CONTRACT_DATA = 'SR_CONTRACT_DATA';
export const SR_CONTRACT_BY_ID = 'SR_CONTRACT_BY_ID';
export const SR_TYPE_CONFIG_DATA = 'SR_TYPE_CONFIG_DATA';
export const SR_TYPE_CONFIG_DATA_ID = 'SR_TYPE_CONFIG_DATA_ID';
export const SR_CONTRACT_RESET = 'SR_CONTRACT_RESET';
export const SR_POSTED_RESULTS_SUCCESS = 'SR_POSTED_RESULTS_SUCCESS';
export const SR_CALC_RESULTS_SUCCESS = 'SR_CALC_RESULTS_SUCCESS';
export const SR_CALC_ANALYSIS_RESULTS_SUCCESS = 'SR_CALC_ANALYSIS_RESULTS_SUCCESS';
